import {
  type MutationOptions,
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import {
  getClassPasswordApiQueryKey,
  type ClassPassword,
} from '../use-get-class-password-api/use-get-class-password-api';

export async function createClassPasswordApi(): Promise<ClassPassword> {
  return fetcher<ClassPassword>('/class-passwords', {
    method: 'POST',
    service: '/roster',
    version: '/v1',
  });
}

export function useCreateClassPasswordApi(
  customMutationOptions?: Omit<
    MutationOptions<ClassPassword, ApiError, void>,
    'mutationFn'
  >
): UseMutationResult<ClassPassword, ApiError, void> {
  const queryClient = useQueryClient();
  const { onSuccess, ...opts } = customMutationOptions ?? {};

  return useMutation({
    mutationFn: () => createClassPasswordApi(),
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(getClassPasswordApiQueryKey(), data);

      onSuccess?.(data, variables, context);
    },
    ...opts,
  });
}
